function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { getLocation } from "@faire/web--source/common/globals/getLocation";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
export var getGroupName = function getGroupName(url, entry) {
  var location = getLocation();
  if (entry.requestStart === 0 && entry.responseStart === 0) {
    return "no-timing-info";
  } else if (isAppStaticCdn(url)) {
    if (url.pathname.startsWith("/static/js/") || url.pathname.startsWith("/_next/static/chunks/")) {
      return "faire-app-script";
    } else {
      return "faire-app-asset";
    }
  } else if (url.host === (location === null || location === void 0 ? void 0 : location.host) && url.pathname.startsWith("/api/")) {
    return "faire-api-request";
  } else {
    return "other";
  }
};
function isAppStaticCdn(url) {
  if (url.host === "cdn.faire.com" || url.host === "localhost:3000") {
    return url.pathname.startsWith("/static/") || url.pathname.startsWith("/_next/static/");
  }
  return false;
}
export var collectInfoByGroup = function collectInfoByGroup(entries) {
  if (!entries) {
    return {};
  }
  var groups = new Map();
  var _iterator = _createForOfIteratorHelper(entries),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var entry = _step.value;
      if (entry == null || entry.name == null || entry.decodedBodySize == null || entry.encodedBodySize == null || entry.transferSize == null) {
        continue;
      }
      var url = new URL(entry.name);
      var groupName = getGroupName(url, entry);
      var group = groups.get(groupName);
      if (group == null) {
        group = {
          encoded: 0,
          decoded: 0,
          transfer: 0,
          count: 0
        };
        groups.set(groupName, group);
      }
      group.decoded += entry.decodedBodySize;
      group.encoded += entry.encodedBodySize;
      group.transfer += entry.transferSize;
      group.count += 1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return Object.fromEntries(groups.entries());
};
export var getInitialLoadResourceEntries = function getInitialLoadResourceEntries() {
  var _getWindow, _getWindow$performanc, _getWindow$performanc2;
  return (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow$performanc = _getWindow.performance) === null || _getWindow$performanc === void 0 ? void 0 : (_getWindow$performanc2 = _getWindow$performanc.getEntriesByType) === null || _getWindow$performanc2 === void 0 ? void 0 : _getWindow$performanc2.call(_getWindow$performanc, "resource");
};
var roundToKb = function roundToKb(value) {
  return Math.round(value / 1024);
};
var createArraySummary = function createArraySummary(summary) {
  if (summary) {
    return [roundToKb(summary.encoded), roundToKb(summary.decoded), roundToKb(summary.transfer), summary.count];
  } else {
    return undefined;
  }
};
export var getPageWeightInfo = function getPageWeightInfo(entries) {
  var groups = collectInfoByGroup(entries);
  return {
    appAsset: createArraySummary(groups["faire-app-asset"]),
    appScript: createArraySummary(groups["faire-app-script"]),
    apiRequest: createArraySummary(groups["faire-api-request"])
  };
};